import { createSelector } from '@reduxjs/toolkit';
const getForms = (state) => state.forms;
const getFormValues = createSelector(getForms, (_, id) => id, (forms, id) => forms[id] || {});
export const FormsSelector = {
    getFormValues,
    getForms,
};
